export default __webpack_public_path__ + "static/media/logotype.ddbb3a0c.svg";